var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar detalhe`
                                  : "Novo Detalhe"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.viewData.powerPlant
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-breadcrumb", {
                            attrs: {
                              items: [
                                {
                                  text: "Usina " + _vm.viewData.powerPlant.name,
                                  href: `#/power-plant/${_vm.viewData.powerPlant.id}/data`
                                },
                                {
                                  text: "Cadastro Detalhe",
                                  href: "#",
                                  active: true
                                }
                              ]
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Data inicial",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("start"),
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.start,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "start", $$v)
                                      },
                                      expression: "state.start"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("start")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Data final",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("end"),
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.end,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "end", $$v)
                                      },
                                      expression: "state.end"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("end")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Potência Instalada",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder:
                                        "Informe a potência instalada",
                                      state: _vm.isOk("powerInstalled")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.powerInstalled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "powerInstalled",
                                          $$v
                                        )
                                      },
                                      expression: "state.powerInstalled"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      _vm._s(_vm.getError("powerInstalled"))
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Injeção projetada",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder:
                                        "Informe a injeção projetada",
                                      state: _vm.isOk("projectedInjection")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.projectedInjection,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "projectedInjection",
                                          $$v
                                        )
                                      },
                                      expression: "state.projectedInjection"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      _vm._s(_vm.getError("projectedInjection"))
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Injeção disponível",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder:
                                        "Informe a injeção projetada",
                                      state: _vm.isOk("availableInjection")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.availableInjection,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "availableInjection",
                                          $$v
                                        )
                                      },
                                      expression: "state.availableInjection"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      _vm._s(_vm.getError("availableInjection"))
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Injeção efetiva",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe a injeção efetiva",
                                      state: _vm.isOk("injection")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.injection,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "injection", $$v)
                                      },
                                      expression: "state.injection"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("injection")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Créditos",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe os créditos",
                                      state: _vm.isOk("credits")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.credits,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "credits", $$v)
                                      },
                                      expression: "state.credits"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("credits")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Capex",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Capex",
                                      state: _vm.isOk("capex")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.capex,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "capex", $$v)
                                      },
                                      expression: "state.capex"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("capex")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Opex",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Opex",
                                      state: _vm.isOk("opex")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.opex,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "opex", $$v)
                                      },
                                      expression: "state.opex"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("opex")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }